import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import 'bootstrap/dist/css/bootstrap.min.css';
import 'bootstrap/dist/js/bootstrap.min.js';
import 'react-notifications/lib/notifications.css';
import '@mantine/core/styles.css';
// import { loadComponents, getState } from "loadable-components";


// const rootElement = document.getElementById("root");
// ReactDOM.render(
//   <React.Fragment>
//     <App />
//     <NotificationContainer />
//   </React.Fragment>,
//   document.getElementById('root')
// );
const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.Fragment>
    <App />
  </React.Fragment>
);

reportWebVitals();

// const rootElement = document.getElementById("root");
// // ReactDOM.render(
// //   <React.Fragment>
// //     <App />
// //     <NotificationContainer />
// //   </React.Fragment>,
// //   document.getElementById('root')
// // );

// window.snapSaveState = () => getState();

// loadComponents()
//   .then(() => ReactDOM.hydrate(<App />, rootElement))
//   .catch(() => ReactDOM.render(<App />, rootElement));

// // If you want to start measuring performance in your app, pass a function
// // to log results (for example: reportWebVitals(console.log))
// // or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
// reportWebVitals();
